import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row, Typography } from 'seagull';
export const UserActionStatus = (param)=>{
    let { Icon, iconSkin, text, preserveWhitespace, testId } = param;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 8,
        alignItems: "start",
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                skin: iconSkin,
                children: /*#__PURE__*/ _jsx(Icon, {
                    size: 20
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                showWhiteSpaces: preserveWhitespace,
                children: text
            })
        ]
    });
};
